<template>
     <el-cascader 
        class="filterItem-value"
        collapse-tags
        collapse-tags-tooltip
        clearable
        :props="configData"
        v-model="filterItem.value"
        :options="options" filterable>
    </el-cascader>
</template>

<script>
    import baseFilter from "../../BaseFilter"
    import ShengShi from "@/assets/data/sheng.json"
    

    export default {
        name:"PositionFieldFilter",
        mixins:[baseFilter],
        data:function(){
            return {
                configData:{
                    checkStrictly: true,
                    value:"value",
                    label:"value",
                    children:"children"
                },
                options:[]
            }
        },
        created:function(){
            this.options = ShengShi;
        }
    }
</script>